import { api } from 'app/api';
import { ApiResponse, InvoiceDto, InvoicesParameters } from 'dtos';
import { URIQuery, openPdf } from 'utils';
import { getPdf } from './report';

export const getInvoices = async (parameters: InvoicesParameters): Promise<ApiResponse<InvoiceDto[]>> =>
  await api.get<ApiResponse<InvoiceDto[]>>('invoices' + URIQuery({ ...parameters })).then(res => res.data);

export const getInvoiceByInvoiceNumber = async (invoiceNumber: string): Promise<ApiResponse<InvoiceDto>> =>
  await api.get<ApiResponse<InvoiceDto>>('invoices/' + invoiceNumber).then(res => res.data);

export const createInvoice = async (values: InvoiceDto): Promise<ApiResponse<InvoiceDto>> =>
  await api.post<ApiResponse<InvoiceDto>>('invoices', values).then(res => res.data);

export const updateInvoice = async (values: InvoiceDto): Promise<ApiResponse<InvoiceDto>> =>
  await api.put<ApiResponse<InvoiceDto>>('invoices', values).then(res => res.data);

export const deleteInvoice = async (invoiceNumber: string): Promise<null> =>
  await api.delete('invoices/' + encodeURIComponent(invoiceNumber)).then(res => res.data);

const previewPdf = async (requestUrl: string): Promise<void> => openPdf(await getPdf(requestUrl));

export const previewInvoice = async (invoiceNumber: string): Promise<void> =>
  await previewPdf(`invoices/${encodeURIComponent(invoiceNumber)}/preview-invoice`);

export const previewReportSummary = async (invoiceNumber: string): Promise<void> =>
  await previewPdf(`invoices/${encodeURIComponent(invoiceNumber)}/preview-report-summary`);

export const previewCombineInvoice = async (invoiceNumber: string): Promise<void> =>
  await previewPdf(`invoices/${encodeURIComponent(invoiceNumber)}/preview-combine-invoice`);

export const previewRecapSheet = async (invoiceNumber: string): Promise<void> =>
  await previewPdf(`invoices/${encodeURIComponent(invoiceNumber)}/preview-recap-sheet`);

export const previewFieldReports = async (invoiceNumber: string): Promise<void> =>
  await previewPdf(`invoices/${encodeURIComponent(invoiceNumber)}/preview-field-reports`);
